/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { SegmentedOption } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function CompareView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1', minWidth: '230px' }}>
          {' '}
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '9px',
              background: 'color-mix(in srgb, var(--acc-fill) 14%, transparent)',
              border: '1px solid color-mix(in srgb, var(--acc-fill) 30%, transparent)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 'none',
            }}
          >
            <i className="ph ph-git-diff" style={{ fontSize: '16px', color: 'var(--acc)' }}></i>
          </div>{' '}
          <div>
            <div style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em' }}>
              Account Comparison
            </div>
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '2px' }}>
              Side-by-side performance analysis across your trading accounts
            </div>
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            gap: '2px',
            padding: '3px',
            borderRadius: '99px',
            border: '1px solid var(--l8)',
            flex: 'none',
          }}
        >
          {' '}
          {(m.cmpPeriods ?? []).map((p, i178) => (
            <Fragment key={i178}>
              {' '}
              <SegmentedOption
                bg={p?.bg}
                fg={p?.fg}
                fw={p?.fw}
                variant="c"
                onClick={p?.go}
                aria-label={dc.s(p?.label)}
              >
                {dc.t(p?.label)}
              </SegmentedOption>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '14px 16px',
        }}
      >
        {' '}
        <div style={{ fontSize: '12px', fontWeight: '500' }}>Select Accounts to Compare (min 2)</div>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '11px' }}>
          {' '}
          {(m.cmpPicker ?? []).map((a, i179) => (
            <Fragment key={i179}>
              {' '}
              <button
                className="scp-d9c1ec4"
                onClick={a?.go}
                aria-label={`Toggle ${dc.s(a?.nickname)}`}
                aria-pressed={dc.b(a?.on)}
                style={dc.css(
                  `display:flex;align-items:center;gap:9px;padding:9px 14px;border-radius:11px;border:1px solid ${dc.s(a?.bd)};background:${dc.s(a?.bg)};cursor:pointer;text-align:left`,
                )}
              >
                {' '}
                <span
                  style={dc.css(
                    `width:8px;height:8px;border-radius:50%;background:${dc.s(a?.dot)};flex:none`,
                  )}
                ></span>{' '}
                <i
                  className={`ph ${dc.s(a?.icon)}`}
                  style={dc.css(`font-size:15px;color:${dc.s(a?.iconFg)};flex:none`)}
                ></i>{' '}
                <div>
                  <div style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(a?.nickname)}</div>
                  <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '1px' }}>
                    {dc.t(a?.meta)}
                  </div>
                </div>{' '}
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      {m.cmpTooFew ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '44px 20px',
              textAlign: 'center',
            }}
          >
            <i className="ph ph-git-diff" style={{ fontSize: '28px', color: 'var(--ghost)' }}></i>
            <div style={{ fontSize: '13px', color: 'var(--text-mid)', marginTop: '10px' }}>
              Select at least 2 accounts
            </div>
            <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '4px' }}>
              Choose accounts above to see a side-by-side comparison
            </div>
          </div>{' '}
        </>
      ) : null}{' '}
      {m.cmpEnough ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,220px),1fr))',
                gap: '12px',
              }}
            >
              {' '}
              {(m.cmpStatCards ?? []).map((s, i180) => (
                <Fragment key={i180}>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '13px 16px',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    {' '}
                    <div
                      style={dc.css(
                        `position:absolute;left:0;top:0;bottom:0;width:3px;background:${dc.s(s?.colour)}`,
                      )}
                    ></div>{' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', paddingLeft: '6px' }}>
                      <span
                        style={dc.css(`width:7px;height:7px;border-radius:50%;background:${dc.s(s?.colour)}`)}
                      ></span>
                      <span style={dc.css(`font-size:11px;font-weight:500;color:${dc.s(s?.ink)}`)}>
                        {dc.t(s?.nickname)}
                      </span>
                    </div>{' '}
                    <div
                      style={dc.css(
                        `padding-left:6px;margin-top:8px;font-size:20px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(s?.netFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(s?.net)}
                    </div>{' '}
                    <svg
                      viewBox="0 0 120 28"
                      preserveAspectRatio="none"
                      style={{ width: '100%', height: '28px', marginTop: '6px' }}
                    >
                      <path
                        d={dc.a(s?.spark)}
                        fill="none"
                        stroke={dc.a(s?.colour)}
                        strokeWidth="1.4"
                        vectorEffect="non-scaling-stroke"
                      ></path>
                    </svg>{' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        paddingLeft: '6px',
                        marginTop: '6px',
                        fontSize: '10px',
                        color: 'var(--muted2)',
                      }}
                    >
                      <span>
                        {dc.t(s?.wr)}
                        {' win rate'}
                      </span>
                      <span>·</span>
                      <span>{dc.t(s?.trades)}</span>
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            {m.cmpWinner ? (
              <>
                {' '}
                <div
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid color-mix(in srgb, var(--pos) 25%, var(--card-line))',
                    boxShadow: 'var(--shadow-card)',
                    borderRadius: '16px',
                    padding: '13px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '11px',
                  }}
                >
                  {' '}
                  <i className="ph-fill ph-trophy" style={{ fontSize: '16px', color: 'var(--amb)' }}></i>{' '}
                  <div style={{ fontSize: '11.5px' }}>
                    <span style={dc.css(`color:${dc.s(m.cmpWinner?.ink)};font-weight:600`)}>
                      {dc.t(m.cmpWinner?.nickname)}
                    </span>
                    <span style={{ color: 'var(--muted)' }}>
                      {' is leading this period with '}
                      {dc.t(m.cmpWinner?.net)}
                      {' net P&L at '}
                      {dc.t(m.cmpWinner?.wr)}
                      {' win rate.'}
                    </span>
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              {' '}
              <div style={{ padding: '12px 16px', fontSize: '12px', fontWeight: '500' }}>
                Performance Metrics
              </div>{' '}
              <div
                style={dc.css(
                  `display:grid;grid-template-columns:${dc.s(m.cmpCols)};gap:10px;padding:9px 16px;border-top:1px solid var(--l6);border-bottom:1px solid var(--l8);font-size:9px;letter-spacing:0.11em;text-transform:uppercase;color:var(--muted2);font-weight:600`,
                )}
              >
                {' '}
                <span>Metric</span>{' '}
                {(m.cmpHeads ?? []).map((hd, i181) => (
                  <Fragment key={i181}>
                    <span
                      style={dc.css(
                        `text-align:right;color:${dc.s(hd?.ink)};display:inline-flex;align-items:center;justify-content:flex-end;gap:6px`,
                      )}
                    >
                      <span
                        style={dc.css(`width:7px;height:7px;border-radius:50%;background:${dc.s(hd?.dot)}`)}
                      ></span>
                      {dc.t(hd?.nickname)}
                    </span>
                  </Fragment>
                ))}{' '}
              </div>{' '}
              {(m.cmpRows ?? []).map((r, i182) => (
                <Fragment key={i182}>
                  {' '}
                  <div
                    className="scp-4f3e86a"
                    style={dc.css(
                      `display:grid;grid-template-columns:${dc.s(m.cmpCols)};gap:10px;padding:9px 16px;border-bottom:1px solid var(--l8);font-size:11.5px;align-items:center;background:${dc.s(r?.rowBg)}`,
                    )}
                  >
                    {' '}
                    <span style={{ color: 'var(--muted2)' }}>{dc.t(r?.label)}</span>{' '}
                    {(r?.cells ?? []).map((c, i183) => (
                      <Fragment key={i183}>
                        {' '}
                        <span
                          style={dc.css(
                            `text-align:right;color:${dc.s(c?.c)};font-weight:${dc.s(c?.fw)};font-variant-numeric:tabular-nums;display:inline-flex;align-items:center;justify-content:flex-end;gap:5px`,
                          )}
                        >
                          {dc.t(c?.v)}
                          {c?.best ? (
                            <i
                              className="ph-fill ph-trophy"
                              style={{ fontSize: '10px', color: 'var(--amb)' }}
                            ></i>
                          ) : null}
                        </span>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,330px),1fr))',
                gap: '14px',
                alignItems: 'stretch',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                  <i className="ph ph-chart-line-up" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
                  <span style={{ fontSize: '12px', fontWeight: '500' }}>Cumulative P&L Comparison</span>
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
                  {dc.t(m.cmpCurveNote)}
                </div>{' '}
                <div
                  style={{
                    flex: '1',
                    minHeight: '210px',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '10px',
                  }}
                >
                  {' '}
                  <svg
                    viewBox="0 0 420 150"
                    preserveAspectRatio="none"
                    style={{ width: '100%', flex: '1', minHeight: '0' }}
                  >
                    {' '}
                    <line
                      x1="0"
                      y1={dc.a(m.cmpZeroY)}
                      x2="420"
                      y2={dc.a(m.cmpZeroY)}
                      stroke="var(--l8)"
                    ></line>{' '}
                    {(m.cmpCurves ?? []).map((c, i184) => (
                      <Fragment key={i184}>
                        {' '}
                        <path
                          d={dc.a(c?.path)}
                          fill="none"
                          stroke={dc.a(c?.colour)}
                          strokeWidth="1.6"
                          vectorEffect="non-scaling-stroke"
                        ></path>{' '}
                      </Fragment>
                    ))}{' '}
                  </svg>{' '}
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                    <span
                      style={{ fontSize: '9px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(m.cmpCurveFrom)}
                    </span>
                    <span
                      style={{ fontSize: '9px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(m.cmpCurveTo)}
                    </span>
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '12px',
                    marginTop: '10px',
                    paddingTop: '9px',
                    borderTop: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  {(m.cmpCurves ?? []).map((c, i185) => (
                    <Fragment key={i185}>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '6px',
                          fontSize: '10px',
                          color: 'var(--muted2)',
                        }}
                      >
                        <span
                          style={dc.css(
                            `width:10px;height:2px;border-radius:99px;background:${dc.s(c?.colour)}`,
                          )}
                        ></span>
                        {dc.t(c?.nickname)}
                        <span
                          style={dc.css(
                            `color:${dc.s(c?.endFg)};font-weight:600;font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(c?.end)}
                        </span>
                      </span>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                  <i className="ph ph-polygon" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
                  <span style={{ fontSize: '12px', fontWeight: '500' }}>Performance Radar</span>
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
                  {dc.t(m.cmpRadarNote)}
                </div>{' '}
                <div
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    margin: '12px auto 0',
                    padding: '0 42px',
                    boxSizing: 'border-box',
                    alignSelf: 'center',
                  }}
                >
                  {' '}
                  <div style={{ position: 'relative', width: '100%', aspectRatio: '120 / 124' }}>
                    {' '}
                    <svg
                      viewBox="0 0 120 124"
                      style={{
                        position: 'absolute',
                        inset: '0',
                        width: '100%',
                        height: '100%',
                        display: 'block',
                        overflow: 'visible',
                      }}
                    >
                      {' '}
                      {(m.cmpRadarRings ?? []).map((g, i186) => (
                        <Fragment key={i186}>
                          {' '}
                          <circle
                            cx="60"
                            cy="58"
                            r={dc.a(g?.r)}
                            fill="none"
                            stroke="var(--l8)"
                            strokeWidth="0.5"
                          ></circle>{' '}
                        </Fragment>
                      ))}{' '}
                      {(m.cmpRadarAxes ?? []).map((a, i187) => (
                        <Fragment key={i187}>
                          {' '}
                          <line
                            x1="60"
                            y1="58"
                            x2={dc.a(a?.x2)}
                            y2={dc.a(a?.y2)}
                            stroke="var(--l8)"
                            strokeWidth="0.5"
                          ></line>{' '}
                        </Fragment>
                      ))}{' '}
                      {(m.cmpRadar ?? []).map((r, i188) => (
                        <Fragment key={i188}>
                          {' '}
                          <polygon
                            points={dc.a(r?.pts)}
                            fill={dc.a(r?.colour)}
                            fillOpacity="0.13"
                            stroke={dc.a(r?.colour)}
                            strokeWidth="1"
                          ></polygon>{' '}
                        </Fragment>
                      ))}{' '}
                    </svg>{' '}
                    {(m.cmpRadarRings ?? []).map((g, i189) => (
                      <Fragment key={i189}>
                        {' '}
                        <span
                          style={dc.css(
                            `position:absolute;left:51%;top:${dc.s(g?.tyPct)};transform:translate(0,-50%);font-size:8px;color:var(--faint);font-variant-numeric:tabular-nums;pointer-events:none`,
                          )}
                        >
                          {dc.t(g?.pct)}
                        </span>{' '}
                      </Fragment>
                    ))}{' '}
                    {(m.cmpRadarAxes ?? []).map((a, i190) => (
                      <Fragment key={i190}>
                        {' '}
                        <div
                          style={dc.css(
                            `position:absolute;left:${dc.s(a?.lxPct)};top:${dc.s(a?.lyPct)};transform:${dc.s(a?.tf)};text-align:${dc.s(a?.align)};white-space:nowrap;pointer-events:none`,
                          )}
                        >
                          {' '}
                          <div
                            style={{
                              fontSize: '10px',
                              fontWeight: '600',
                              color: 'var(--text2)',
                              lineHeight: '1.25',
                            }}
                          >
                            {dc.t(a?.label)}
                          </div>{' '}
                          <div
                            style={{
                              fontSize: '8.5px',
                              color: 'var(--faint)',
                              fontVariantNumeric: 'tabular-nums',
                              lineHeight: '1.25',
                            }}
                          >
                            {dc.t(a?.capLabel)}
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    marginTop: '10px',
                    paddingTop: '9px',
                    borderTop: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  {(m.cmpRadar ?? []).map((r, i191) => (
                    <Fragment key={i191}>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {' '}
                        <span
                          style={dc.css(
                            `width:9px;height:9px;border-radius:2px;background:${dc.s(r?.colour)};flex:none`,
                          )}
                        ></span>{' '}
                        <span
                          style={{
                            fontSize: '10.5px',
                            color: 'var(--text2)',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(r?.nickname)}
                        </span>{' '}
                        <span style={{ fontSize: '9.5px', color: 'var(--muted2)', whiteSpace: 'nowrap' }}>
                          {dc.t(r?.leads)}
                        </span>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <i className="ph ph-chart-bar" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
                <span style={{ fontSize: '12px', fontWeight: '500' }}>P&L by Account</span>
              </div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '12px' }}>
                {' '}
                {(m.cmpBars ?? []).map((b, i192) => (
                  <Fragment key={i192}>
                    {' '}
                    <div>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={dc.css(`font-size:11.5px;font-weight:500;color:${dc.s(b?.ink)}`)}>
                          {dc.t(b?.nickname)}
                        </span>
                        <div style={{ flex: '1' }}></div>
                        <span
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(b?.netFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(b?.net)}
                        </span>
                      </div>{' '}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '8px' }}>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              width: '74px',
                              flex: 'none',
                            }}
                          >
                            Gross profit
                          </span>
                          <div
                            style={{
                              flex: '1',
                              height: '6px',
                              borderRadius: '99px',
                              background: 'var(--l6)',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              style={dc.css(
                                `width:${dc.s(b?.gpW)};height:100%;border-radius:99px;background:var(--pos)`,
                              )}
                            ></div>
                          </div>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--pos)',
                              fontVariantNumeric: 'tabular-nums',
                              width: '78px',
                              textAlign: 'right',
                              flex: 'none',
                            }}
                          >
                            {dc.t(b?.gp)}
                          </span>
                        </div>{' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              width: '74px',
                              flex: 'none',
                            }}
                          >
                            Gross loss
                          </span>
                          <div
                            style={{
                              flex: '1',
                              height: '6px',
                              borderRadius: '99px',
                              background: 'var(--l6)',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              style={dc.css(
                                `width:${dc.s(b?.glW)};height:100%;border-radius:99px;background:var(--neg)`,
                              )}
                            ></div>
                          </div>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--neg)',
                              fontVariantNumeric: 'tabular-nums',
                              width: '78px',
                              textAlign: 'right',
                              flex: 'none',
                            }}
                          >
                            {dc.t(b?.gl)}
                          </span>
                        </div>{' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              width: '74px',
                              flex: 'none',
                            }}
                          >
                            Net P&L
                          </span>
                          <div
                            style={{
                              flex: '1',
                              height: '6px',
                              borderRadius: '99px',
                              background: 'var(--l6)',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              style={dc.css(
                                `width:${dc.s(b?.netW)};height:100%;border-radius:99px;background:${dc.s(b?.netBg)}`,
                              )}
                            ></div>
                          </div>
                          <span
                            style={dc.css(
                              `font-size:10px;color:${dc.s(b?.netFg)};font-variant-numeric:tabular-nums;width:78px;text-align:right;flex:none`,
                            )}
                          >
                            {dc.t(b?.net)}
                          </span>
                        </div>{' '}
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <i className="ph ph-coins" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
                <span style={{ fontSize: '12px', fontWeight: '500' }}>Symbol Performance by Account</span>
              </div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,260px),1fr))',
                  gap: '16px',
                  marginTop: '12px',
                  alignItems: 'start',
                }}
              >
                {' '}
                {(m.cmpSymbols ?? []).map((a, i193) => (
                  <Fragment key={i193}>
                    {' '}
                    <div>
                      {' '}
                      <div style={dc.css(`font-size:11px;font-weight:500;color:${dc.s(a?.ink)}`)}>
                        {dc.t(a?.nickname)}
                      </div>{' '}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '9px' }}>
                        {' '}
                        {(a?.syms ?? []).map((s, i194) => (
                          <Fragment key={i194}>
                            {' '}
                            <div>
                              {' '}
                              <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                                <span
                                  style={{
                                    fontSize: '11px',
                                    color: 'var(--text2)',
                                    flex: '1',
                                    minWidth: '0',
                                  }}
                                >
                                  {dc.t(s?.sym)}
                                </span>
                                <span
                                  style={{
                                    fontSize: '9.5px',
                                    color: 'var(--muted2)',
                                    fontVariantNumeric: 'tabular-nums',
                                  }}
                                >
                                  {dc.t(s?.n)}
                                </span>
                                <span
                                  style={dc.css(
                                    `font-size:11px;font-weight:600;color:${dc.s(s?.pnlFg)};font-variant-numeric:tabular-nums`,
                                  )}
                                >
                                  {dc.t(s?.pnl)}
                                </span>
                              </div>{' '}
                              <div
                                style={{
                                  height: '3px',
                                  borderRadius: '99px',
                                  background: 'var(--l6)',
                                  marginTop: '5px',
                                  overflow: 'hidden',
                                }}
                              >
                                <div
                                  style={dc.css(
                                    `width:${dc.s(s?.w)};height:100%;border-radius:99px;background:${dc.s(s?.bar)}`,
                                  )}
                                ></div>
                              </div>{' '}
                            </div>{' '}
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                      {a?.empty ? (
                        <div style={{ fontSize: '10.5px', color: 'var(--faint)', marginTop: '8px' }}>
                          No trades in this period
                        </div>
                      ) : null}{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
